import { Component, forwardRef } from 'react';
import {arrayMove, SortableContainer, SortableElement} from 'react-sortable-hoc';
import ProductItem from '../../common/product-item';
import store, {history} from '../../../../../store';
import ConfirmPopup from '../../../../common/confirm-popup';
import {deleteCategory, reorderCategories} from '../../../../../actions/categories';

const CategoryItem = SortableElement(forwardRef(({item, onDelete, onEdit}, ref) => (
  <ProductItem
    ref={ref}
    deleteDisabled={item.attributes['category-status'] !== 'DRAFT'}
    item={item}
    itemType="Category"
    onDelete={onDelete}
    onEdit={onEdit}
    status={item.attributes['category-status']}
  />
)));

const CategoriesContainer = SortableContainer(forwardRef(({items, onDelete, onEdit}, ref) => (
  <div ref={ref}>
    {items.map((value, index) => (
      <CategoryItem
        index={index}
        item={value}
        key={`item-${value.id}`}
        onDelete={onDelete}
        onEdit={onEdit}
      />
    ))}
  </div>
)));

class CategoriesList extends Component {
  toggleDeletePopup = (id) => {
    this.setState({
      delete: {
        show: !this.state.delete.show,
        id
      }
    });
  };
  handleDelete = (result) => {
    const {id} = this.state.delete;
    this.setState({delete: {show: false}});
    if (result) {
      store.dispatch(deleteCategory(id));
    }
  };
  handleEdit = (id) => {
    history.push(`/admin/categories/${id}`);
  };
  handleSort = ({oldIndex, newIndex}) => {
    if (oldIndex !== newIndex) {
      const newOrdering = arrayMove(this.props.categories, oldIndex, newIndex);
      store.dispatch(reorderCategories(newOrdering));
    }
  };

  constructor(props) {
    super(props);

    this.state = {
      delete: {
        show: false
      }
    };
  }

  render() {
    return (
      <div>
        {/*
          Activate the drag by MOVEMENT (distance) rather than a timed press-hold.
          pressDelay={150} required holding the mouse still for 150ms before a drag
          started; any small movement inside that window cancelled it, which reads as
          "sometimes I cannot drag the elements" (IGN-2362). distance has no timer to
          race and is react-sortable-hoc's recommended trigger for mouse input.
        */}
        <CategoriesContainer
          distance={8}
          helperClass="product-reordering"
          items={this.props.categories}
          lockAxis="y"
          onDelete={this.toggleDeletePopup}
          onEdit={this.handleEdit}
          onSortEnd={this.handleSort}
        />

        {
          this.state.delete.show && (
            <ConfirmPopup
              header="DELETE CATEGORY?"
              onClose={this.handleDelete}
            >
              <p>
                Are you sure you want to delete the selected category?
              </p>
            </ConfirmPopup>
          )}
      </div>
    );
  }
}

export default CategoriesList;
